import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex w-full px-2w py-1w rounded border border-neutral-300 bg-white text-body1 text-black placeholder:text-neutral-200 focus:border-neutral-400 focus:outline-none disabled:cursor-not-allowed disabled:bg-neutral-200",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
